import { useAppSelector } from '@hooks/reduxHooks';
import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { PipeAll } from '../models';

export function usePipes() {
  const { visible } = useAppSelector(({ dashboardReducer }) => dashboardReducer?.controller);

  const { data, ...arg } = useQuery<{ pipeId?: number; pipeStatusId?: number }>(
    ['dashboard-v2-pipe-all'],
    async () => {
      const { data } = await $api.get('/v1/pipe/all');

      const orderPipes = data?.data?.find((item: PipeAll) => item?.orders === 1);
      const successStatusPipes = orderPipes?.pipeStatuses?.find(
        (prev: PipeAll['pipeStatuses'][number]) => prev?.type === 'SUCCESS'
      );

      return { pipeId: orderPipes?.id, pipeStatusId: successStatusPipes?.id };
    },
    {
      enabled: visible,
      staleTime: Infinity,
      cacheTime: Infinity
    }
  );

  return { ...data, ...arg };
}
